import { render, staticRenderFns } from "./HomeMancomunoView.vue?vue&type=template&id=4954cf70&"
import script from "./HomeMancomunoView.vue?vue&type=script&lang=js&"
export * from "./HomeMancomunoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports